import React from 'react'
import AboutUsC from '../../Components/AboutUsC/AboutUsC'
import { useLocation } from "react-router-dom"

const AboutUs = () => {

  const location = useLocation()
  const position = location.pathname.split('/')[2]
  console.log(position)

  return (
    <div>
        <AboutUsC position={position} />
    </div>
  )
}

export default AboutUs